function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "rings");

var SvgRings = function SvgRings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "bfaae061-9ca9-47f0-8f44-70ffaccc8865",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("g", {
    id: "f5770bdb-8397-4b28-b726-17c61cbf7602",
    "data-name": "circles"
  }, React.createElement("g", {
    id: "aea0b522-296c-4f02-b997-c70c457d3ad4",
    "data-name": "Ellipse 3"
  }, React.createElement("ellipse", {
    cx: 220.74,
    cy: 276.55,
    rx: 218.74,
    ry: 221.45,
    style: {
      fill: "none"
    }
  }), React.createElement("ellipse", {
    cx: 220.74,
    cy: 276.55,
    rx: 218.24,
    ry: 220.95,
    style: {
      fill: "none",
      stroke: "#8cb5d8"
    }
  })), React.createElement("g", {
    id: "a6d95454-c733-46a0-9895-32eb6393845b",
    "data-name": "Ellipse 6"
  }, React.createElement("ellipse", {
    cx: 337.3,
    cy: 250,
    rx: 160.7,
    ry: 162.83,
    style: {
      fill: "none"
    }
  }), React.createElement("ellipse", {
    cx: 337.3,
    cy: 250,
    rx: 160.21,
    ry: 162.33,
    style: {
      fill: "none",
      stroke: "#8cb5d8"
    }
  })), React.createElement("g", {
    id: "a8f91062-21ca-415f-a62a-791ca834472d",
    "data-name": "Ellipse 4"
  }, React.createElement("ellipse", {
    cx: 233.63,
    cy: 207.41,
    rx: 202.86,
    ry: 205.41,
    style: {
      fill: "none"
    }
  }), React.createElement("ellipse", {
    cx: 233.63,
    cy: 207.41,
    rx: 202.37,
    ry: 204.91,
    style: {
      fill: "none",
      stroke: "#1d1d1d"
    }
  })), React.createElement("g", {
    id: "e44d0267-56e2-460a-a9da-7e482a825597",
    "data-name": "Ellipse 5"
  }, React.createElement("ellipse", {
    cx: 275.3,
    cy: 276.55,
    rx: 202.86,
    ry: 204.41,
    style: {
      fill: "none"
    }
  }), React.createElement("ellipse", {
    cx: 275.3,
    cy: 276.55,
    rx: 202.37,
    ry: 203.91,
    style: {
      fill: "none",
      stroke: "#1d1d1d"
    }
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rings.e1578e8f.svg";
export { ForwardRef as ReactComponent };